import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from "@angular/forms";
import { GenericFormService } from '../service/generic-form.service';
import { FieldModel } from '../model/field.model';
import { Subject } from 'rxjs';

@Component({
	selector: 'cv-input-switch-field',
	templateUrl: './input-switch-field.component.html',
	styleUrls: ['./input-switch-field.component.scss'],
})
export class InputSwitchFieldComponent implements OnInit {
	@Input() fieldOptions: any;
	@Input() control: FormControl;
	@Input() field: FieldModel;
	@Input() value: any;
	options: any;
	private atComponentDestroy: Subject<any> = new Subject<any>();

	constructor(
		private formService: GenericFormService
	) { }

	ngOnInit(): void {
		this.options = this.field.options;
		if(this.field.disabled){
			this.control.disable();
		}
	}

	/**
	 * Trigger the field onChange
	 *
	 * @param $event
	 * @param field
	 * @param row
	 */
	onChange($event: any): void {
		if ('UIEvents' in this.field && this.field.UIEvents.onChange) {
			this.formService.onChangeOptions$.next({
				field: this.field,
				event: $event
			});
		}
	}

}
